import React from "react";
import Dialog from "@material-ui/core/Dialog";
import StyledDialog from "../../updateGrRecord/Dialog";

const BatchAllocationSuccessPopup = ({ open, onClose }) => (
  <Dialog open={open} fullWidth>
    <StyledDialog
      handleClose={onClose}
      title="Batch Allocation updated successfully"
    />
  </Dialog>
);

export default BatchAllocationSuccessPopup;
